import React from "react";
import { Typography } from "@kelp-dao/kernel-design-system";
import FeatureCard from "./FeatureCard";
import { FEATURES_DATA } from "./constants";

interface FeaturesSectionProps {
  title?: string;
  className?: string;
}

const FeaturesSection: React.FC<FeaturesSectionProps> = ({
  title = "ETH works, rsETH outworks",
  className = "",
}) => {
  return (
    <section
      className={`w-full px-4 md:px-8 lg:px-20 xl:px-40 py-12 md:py-16 lg:py-20 xl:max-w-[1536px] mx-auto ${className}`}
    >
      {/* Section Title */}
      {title && (
        <Typography
          type="heading"
          variant="large"
          className="text-text-primary text-center mb-4 md:mb-10 font-medium text-2xl md:text-4xl lg:text-5xl"
        >
          {title}
        </Typography>
      )}

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6 lg:gap-6 max-w-7xl mx-auto">
        {FEATURES_DATA.map((feature, index) => (
          <FeatureCard
            key={index}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
